import { BaseApi as Base } from '@micromag/data';

class StoriesQuizApi extends Base {
    resultsByScreen(storyId, screenId) {
        return this.requestGet(
            this.route('stories.quiz.show', {
                story: storyId,
                screen: screenId,
            }),
        );
    }
}

export default StoriesQuizApi;
